/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import { Table } from "antd";

const Datatable = ({
  props,
  columns,
  dataSource,
  total,
  onPageChange,
  loading,
  pagination,
}) => {
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const onSelectChange = (newSelectedRowKeys) => {
  //   setSelectedRowKeys(newSelectedRowKeys);
  // };

  // const rowSelection = {
  //   selectedRowKeys,
  //   onChange: onSelectChange,
  // };

  const currentPageRef = useRef(1);

  const handleTableChange = (pagination) => {
    onPageChange(pagination.current - 1, pagination.pageSize);
    if (currentPageRef.current !== pagination.current) {
      currentPageRef.current = pagination.current;
    }
  };

  return (
    <Table
      key={props}
      className="table datanew dataTable no-footer"
      // rowSelection={rowSelection}
      columns={columns}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      pagination={pagination}
      onChange={handleTableChange}
      loading={loading}
    />
  );
};

export default Datatable;
